import { Component, Input, OnInit } from '@angular/core';
import { Entry } from 'contentful';
import { FunctionalCapabilitiesOrderManagementPage } from 'src/app/model/page/group/api-docs/functional-capabilities-order-management-page';
import { ContentfulService } from 'src/app/service/contentful.service';
import { SharedDataService } from 'src/app/service/shared-data.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-functional-capabilities-order-management-page',
  templateUrl: './functional-capabilities-order-management-page.component.html',
  styleUrls: ['./functional-capabilities-order-management-page.component.scss']
})
export class FunctionalCapabilitiesOrderManagementPageComponent implements OnInit {
  @Input() apiName: string = '';
  @Input() apiTabs: string[] = [];
  @Input() apiTabsClass: string[] = [];
  @Input() pageTitle: string = '';
  @Input() isTab: boolean = false;
  @Input() href: string = '';
  @Input() isTabOverride: boolean = false;
  @Input() selectedIndex: number = 0;

  functionalCapabilitiesOrderManagementPage: FunctionalCapabilitiesOrderManagementPage = {} as FunctionalCapabilitiesOrderManagementPage;

  constructor(private contentfulService: ContentfulService, private sharedDataService: SharedDataService) {}

  ngOnInitWithPageTitle(pageTitle: string) {
    // console.log('>>>> >>>> FunctionalCapabilitiesOrderManagementPageComponent invoked ngOnInitWithPageTitle');

    this.selectedIndex = 0;

    this.apiTabs.forEach((tab, index) => {
      if (this.apiName + ' ' + tab === pageTitle) {
        this.selectedIndex = index;
      }
    });

    this.setPageTitle(pageTitle);
  }

  setPageTitle(value: string) {
    // console.log(value);

    if (value.length > 0) {
      this.pageTitle = value;
    }

    this.ngOnInit();
  }

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'functional-capabilities-order-management') {
        this.functionalCapabilitiesOrderManagementPage.htmlTitle = title.htmlTitle;
      }
    });
    // console.log('apiName : ' + this.apiName);
    // console.log('pageTitle : ' + this.pageTitle);

    const query = { 'fields.title': this.pageTitle };
    this.contentfulService.getPageContentResponse(query).then((orderManagementPageEntries) => {
      this.functionalCapabilitiesOrderManagementPage.sections = [];
      this.functionalCapabilitiesOrderManagementPage.ribbonTileSections = [];

      this.mapBanner(orderManagementPageEntries.includes.Entry);
      this.sharedDataService.addSharedData(this.functionalCapabilitiesOrderManagementPage.banner);
      this.mapRibbonSection(orderManagementPageEntries.includes.Entry);
      this.mapSection(orderManagementPageEntries.includes.Entry);
      this.mapPageInfo(orderManagementPageEntries.items);
    });
  }

  private mapBanner(orderManagementPageEntries: Entry<any>[]) {
    orderManagementPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let imageDetails: any = entry.fields['image'];
    let videoDetails: any = entry.fields['video'];
    this.functionalCapabilitiesOrderManagementPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: imageDetails.fields.file.url as string,
      video: videoDetails?.fields?.file?.url  as string
    };
  }

  private mapSection(orderManagementPageEntries: Entry<any>[]) {
    orderManagementPageEntries
      .filter((entry) => ModelValidator.isSection(entry))
      .forEach((entry) => {
        if (entry.fields['group'] === 'section') {
          this.mapEntryToSection(entry);
        }
      });
  }

  private mapRibbonSection(orderManagementPageEntries: Entry<any>[]) {
    orderManagementPageEntries
      .filter((entry) => ModelValidator.isSection(entry))
      .forEach((entry) => {
        if (entry.fields['group'] === 'ribbon-tile') {
          this.mapEntryToRibbonTileSection(entry);
        }
      });
  }

  private mapEntryToSection(entry: Entry<any>) {
    this.functionalCapabilitiesOrderManagementPage.sections.push({
      title: entry.fields['title'] as string,
      order: entry.fields['order'] as number,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      subBody: entry.fields['subBody'] as string,
      heading: entry.fields['heading'] as string,
      ribbonTileSections: this.functionalCapabilitiesOrderManagementPage.ribbonTileSections.filter((ribbonTileSections) => ribbonTileSections.category === entry.fields['title'])
    });
    this.functionalCapabilitiesOrderManagementPage.sections.sort((a, b) => a.order - b.order);
  }

  private mapEntryToRibbonTileSection(entry: Entry<any>) {
    let tBody: string[] = [];

    let pageBody:any=entry.fields['body'] as string;

    pageBody.split('@').forEach((apiArrow: any) => {
      if (apiArrow !== '') {
        tBody.push(apiArrow);
      }
    });

    
    let givenTitle:any=entry.fields['title'] as string;
    let pageTitle=givenTitle.split('#').pop();
    this.functionalCapabilitiesOrderManagementPage.ribbonTileSections.push({
      title: pageTitle,
      body: '',
      bodyArrows: tBody,
      category: entry.fields['category'] as string,
      order: entry.fields['order'] as number,
      group: entry.fields['group'] as string,
      heading: entry.fields['heading'] as string,
      subBody: entry.fields['subBody'] as string,
      sectionClass: entry.fields['sectionClass'] as string
    });
    this.functionalCapabilitiesOrderManagementPage.ribbonTileSections.sort((a, b) => a.order - b.order);
  }

  private mapPageInfo(items: Entry<any>[]) {
    items.forEach((entry: any) => {
      let editorDetails = entry.fields?.editorDetails?.split('#');
      this.functionalCapabilitiesOrderManagementPage.banner.lastUpdated = entry.fields?.lastUpdated;
      this.functionalCapabilitiesOrderManagementPage.banner.url = entry.fields?.url;
      this.functionalCapabilitiesOrderManagementPage.banner.editorEmail = editorDetails?.pop();
      this.functionalCapabilitiesOrderManagementPage.banner.editorShortName = editorDetails?.pop();
      this.functionalCapabilitiesOrderManagementPage.banner.editorFullName = editorDetails?.pop();
      this.functionalCapabilitiesOrderManagementPage.htmlTitle = entry.fields.htmlTitle;
    });
  }
}
